import api from './api';

export const GetUsersByNameOrEmail = async (texto) => {

    try {

        const resposta = await api.get(`GetUsersByNameOrEmail?texto=${texto}`);
        const posts = resposta;

        return posts;
    } catch (error) {

            return error.response;

    }
};
